export const UI_SIZE = {
  XS: 'xs',
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
  XL: 'xl',
} as const;

export type UiSize = (typeof UI_SIZE)[keyof typeof UI_SIZE];
